import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import * as XLSX from 'xlsx';//CDPJ
import { isNullOrUndefined } from 'util';
import { UploadfilesService } from '../../advantage/advantageservices/uploadfiles.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';

import { Cxcencndcli } from "../cxcinterfaces/cxcencndcli";
import { Cxcdetndcli } from "../cxcinterfaces/cxcdetndcli";
import { CxcimportarndService } from "../cxcservicios/cxcimportarnd.service";
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';

@Component({
  selector: 'app-cxcimportarnd',
  templateUrl: './cxcimportarnd.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxcimportarndComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef

  indicador: any;
  permisoImpnd: SegMaePermiso;

  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;

  lblestado


  public frameworkComponents;
  rowSelection = 'multiple';
  defaultCxcdetndcli;
  rowStyle;
  largo: string;
  detndcliSelected: Cxcdetndcli;
  index = 0;

  displayDialogBus: boolean;
  displayDialogBusquedaFast: boolean;
  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  where: string;
  opcion: string;
  spin: boolean;
  datosJson;

  // autorizacion
  claveAuth: string;
  autorizacionCodigo: string;
  bolAutorizacion: boolean;
  displayDialogAutorizacion: boolean;
  /*imprimir*/
  auxreporte: number = 0;
  strNombreForma: string;
  displayDialogReportes: boolean;


  columnDefsDetndcli = [
    {
      headerName: 'No.', field: 'DETNDCLI_NUMERO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 80, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Fecha', field: 'DETNDCLI_FECHA',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', editable: (params) => {
        return false
      }, cellEditor: 'cellPrueba', width: 95,
      cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {

        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 20,
          opcionbuscar: true
        }

      }
    },
    // {
    //   headerName: 'Nombre', field: 'CLI_NOMBRE', editable: (params) => {
    //     return false;
    //   }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
    //   onCellDoubleClicked: (params) => {
    //     // this.abrirBanTrnBanEdit(params.data);
    //   }
    // },
    {
      headerName: 'Vendedor', field: 'VEN_CODIGO', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Tipo documento', field: 'DETNDCLI_TIPODOC', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Concepto', field: 'DETNDCLI_CONCEPTO', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Importe', field: 'DETNDCLI_IMPORTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 95, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        ///this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'CI', field: 'TRNCOBRO_NRODOC', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    }
  ];

  constructor(
    public init: NuevoComponentService, public cxcimportarndService: CxcimportarndService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    public uploadFileService: UploadfilesService, private utilitariosService: UtilitariosService
  ) {
    this.agTable()
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };

    this.defaultCxcdetndcli = {
      editable: true,
      objeto: 'cxcdetndcli',
      resizable: true
    };
  }

  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.spin = false;

    this.cxcimportarndService.encndcli[this.indicador] = {};
    this.cxcimportarndService.detndcli = [];
    this.detndcliSelected = {}

    await this.getPermisos()




  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoImpnd = data[0];
        } else {
          this.permisoImpnd = null;
        }
      } else {
        this.permisoImpnd = null;
      }
    } catch (e) {
      this.permisoImpnd = null;
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  manejarSenales(valor) {
    if (valor === 'Primero') {

      this.seleccionarRegistro('P');
    }
    if (valor === 'Anterior') {

      this.seleccionarRegistro('A');
    }
    if (valor === 'Siguiente') {

      this.seleccionarRegistro('S');
    }
    if (valor === 'Ultimo') {

      this.seleccionarRegistro('U');
    }
    if (valor === 'Descargar') {
      this.descargarDemo()
    }
    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Generand') {
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Guarde primero el documento por favor'
        });
        return
      }
      this.validadnotasdebito()
    }
    if (valor === 'Reversand') {
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Guarde primero el documento por favor'
        });
        return
      }
      this.validareversanotasdebito()
    }
    if (valor === 'Buscar') {
      if (this.permisoImpnd.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisoImpnd.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Nuevo') {
      if (this.permisoImpnd.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoImpnd.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoImpnd.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoImpnd.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Borrar') {
      if (this.permisoImpnd.PERTODO === 1) {
        const numci = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
          item.TRNCOBRO_NRODOC).filter(x => x !== null && String(x).trim() !== '')))
        if (numci.length > 0) {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'No se puede eliminar todo el documento porque ya se generaron las notas de débito, debe reversar primero'
          });
          return;
        }
        this.borrar();
      } else {
        if (this.permisoImpnd.PERELIMACION === 1) {
          const numci = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
            item.TRNCOBRO_NRODOC).filter(x => x !== null && String(x).trim() !== '')))
          if (numci.length > 0) {
            this.messageService.add({
              key: 'cxcimpnd',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el documento porque ya se generaron las notas de débito, debe reversar primero'
            });
            return;
          }
          this.borrar();
        } else {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }

  }
  async validadnotasdebito() {
    try {
      this.spin = true
      const numci = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.TRNCOBRO_NRODOC).filter(x => x !== null && String(x).trim() !== '')))

      const data = await this.cxcimportarndService.countregci(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO)
      for (const iterator of data) {
        if (iterator.NUMERO > 0) {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'Las notas de débito ya han sido generadas en el sistema '
          });
          this.spin = false
          return;
        }
      }
      if (numci.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'Las notas de débito ya han sido generadas'
        });
        this.spin = false
        return;
      }

      if (this.cxcimportarndService.detndcli.length === 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'El detalle está vacío'
        });
        this.spin = false
        return;
      }
      this.autorizacionCodigo = 'GENDCLI'
      this.displayDialogAutorizacion = true;

    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar la información para generar las notas de débito '
      });
      this.spin = false
      return;
    }
  }
  comprobarClave() {
    this.utilitariosService.obtenerClave(this.autorizacionCodigo).subscribe((clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        if (this.autorizacionCodigo === 'GENDCLI') {
          this.displayDialogAutorizacion = false;
          this.claveAuth = '';
          this.generarnotasdebito();
        }
        if (this.autorizacionCodigo === 'RVNDCLI') {
          this.displayDialogAutorizacion = false;
          this.claveAuth = '';
          this.reversarnotasdebito();
        }
      } else if (clave !== this.claveAuth) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }
    });
  }
  onHideAutorizacion() {
    if (this.bolAutorizacion === false) {
      if (this.autorizacionCodigo === 'GENDCLI') {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar correctamente para generar los anticipos'

        });
      }
      if (this.autorizacionCodigo === 'RVNDCLI') {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar correctamente para reversar los anticipos'

        });
      }
    }
  }
  async generarnotasdebito() {
    try {
      this.spin = true
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'success',
        summary: 'Información',
        detail: 'Éxito al iniciar el proceso para generar las notas de débito, le informaremos por correo cuando finalice. '
      });
      this.spin = false
      await this.cxcimportarndService.generarnotasdebito(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO);
      await this.auditoriagral.registrarAuditoria('CXC_ENCNDCLI',
        this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO + '/NOTAS-DEBITO-GENERADAS', 'I',
        '', '01', '', '', '', '').toPromise();
      await this.cancelar();


    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al generar las notas de débito'
      });
      console.log(error)
      this.spin = false
    }
  }
  async validareversanotasdebito() {
    try {
      this.spin = true
      const numci = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.TRNCOBRO_NRODOC).filter(x => x !== null && String(x).trim() !== '')))
      if (numci.length === 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'No hay notas de débito para reversar'
        });
        this.spin = false
        return;
      }
      if (this.cxcimportarndService.detndcli.length === 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'El detalle está vacío'
        });
        this.spin = false
        return;
      }
      this.autorizacionCodigo = 'RVNDCLI'
      this.displayDialogAutorizacion = true;
    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar los datos para reversar las notas de débito'
      });
      this.spin = false
      return;
    }
  }
  async reversarnotasdebito() {
    try {
      this.spin = true
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'info',
        summary: 'Información',
        detail: 'Éxito al iniciar el proceso para reversar las notas de débito, le informaremos por correo cuando finalice. '
      });
      this.spin = false
      await this.cxcimportarndService.reversarnotasdebito(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO);
      await this.auditoriagral.registrarAuditoria('CXC_ENCNDCLI',
        this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO + '/NOTAS-DEBITO-REVERSADAS', 'E',
        '', '01', '', '', '', '').toPromise();
      await this.cancelar();


    } catch (error) {
      // this.messageService.add({
      //   key: 'cxcimpnd',
      //   severity: 'error',
      //   summary: 'Error',
      //   detail: 'Ocurrió un error al reversar las notas de débito'
      // });
      console.log(error)
      this.spin = false
    }
  }
  borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'cxcimpndconfirm',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let numero = this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO
          const data = await this.cxcimportarndService.countregci(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO)
          for (const iterator of data) {
            if (iterator.NUMERO > 0) {
              this.messageService.add({
                key: 'cxcimpnd',
                severity: 'error',
                summary: 'Información',
                detail: 'No se puede eliminar todo el documento porque ya se generaron las notas de débito, debe reversar primero '
              });
              return;
            }
          }
          this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO = ''
          await this.cxcimportarndService.borrarRegistro(numero)
          await this.auditoriagral.registrarAuditoria('CXC_ENCNDCLI',
            numero + '/Concepto:' + this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_CONCEPTO, 'E',
            '', '01', '', '', '', '').toPromise();
          await this.cancelar()
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación ' + error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async busqueda() {
    this.opcion = 'BUSCARREG';
    this.types = [
      { label: 'Número', value: 'ENCNDCLI_NUMERO' },
      { label: 'FECHA', value: 'ENCNDCLI_FECHA' },
      { label: 'Concepto', value: 'ENCNDCLI_CONCEPTO' },

    ];
    this.busquedacampos = ['', '', ''];
    this.tabla = 'CXC_ENCNDCLI';
    this.where = ' ENCNDCLI_NUMERO is not null order by 1 desc';
    this.busquedaSer.busquedaRegCxcNDcliente().subscribe((res: any[]) => {
      this.arregloCons = res;
      this.arregloCons.map((dato) => {
        if (dato.ENCNDCLI_FECHA !== null) {
          dato.ENCNDCLI_FECHA = this.datePipe.transform(dato.ENCNDCLI_FECHA, 'dd/MM/yyyy');
        } else {
          dato.ENCNDCLI_FECHA = '';
        }
      });
      this.displayDialogBusquedaFast = true;
    });
  }
  async descargarDemo() {
    try {
      const rs: any = await this.uploadFileService.getDocument('REGISTRO_ND_DEMO.xlsx');
      this.downloadDocument(rs.respuesta, 'REGISTRO_ND_DEMO.xlsx');
    } catch (err) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al encontrar el archivo'
      });
    }
  }
  downloadDocument(strBase64, filename) {
    const byteCharacters = atob(strBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 1000)
  }
  seleccionarRegistro(strTipo) {

    if (strTipo === 'P') {
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'A' || strTipo === 'S') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'U') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = false;
      this.botonUltimo = false;
    }
    let numero = isNullOrUndefined(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO) ? '' : this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO
    this.cxcimportarndService.seleccionarRegistro(strTipo, numero).subscribe((datos: any[]) => {
      if (datos !== null && datos.length > 0) {
        this.encontrarregistro(datos[0].ENCNDCLI_NUMERO);
        //this.encontrarFactura(datos[0], 'sR');
      }
    }, error1 => {

      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al buscar la información' + error1
      });
    });
  }
  async validarGuardar() {
    try {
      this.spin = true
      if (this.cxcimportarndService.detndcli.length === 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle no puede estar vacío'
        });
        this.spin = false
        return;
      }

      const fechanull = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.DETNDCLI_FECHA).filter(x => x === null || String(x).trim() === '')))

      const codclinull = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.CLI_CODIGO).filter(x => x === null || String(x).trim() === '')));

      const importenull = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.DETNDCLI_IMPORTE).filter(x => x === null || String(x).trim() === '')));

      const cntvariosnull = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.CON_CODIGO).filter(x => x === null || String(x).trim() === '')));

      const codvennull = Array.from(new Set(this.cxcimportarndService.detndcli.map(item =>
        item.VEN_CODIGO).filter(x => x === null || String(x).trim() === '')));

      if (isNullOrUndefined(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA) === true ||
        this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA === '') {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'La fecha no puede estar vacía'
        });
        this.spin = false
        return;
      }
      if (fechanull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya fecha está vacía'
        });
        this.spin = false
        return;
      }
      if (codclinull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya código del cliente está vacío'
        });
        this.spin = false
        return;
      }
      if (importenull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo importe está vacío'
        });
        this.spin = false
        return;
      }
      if (codvennull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo codigo del vendedor está vacío'
        });
        this.spin = false
        return;
      }
      if (cntvariosnull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya cuenta de varios está vacía'
        });
        this.spin = false
        return;
      }
      await this.finguardar()
    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar los datos antes de guardar' + error
      });
    }
  }
  async finguardar() {
    try {
      let numero = this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO
      if (isNullOrUndefined(numero) || numero === '') {
        if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA.toString().includes('-')) {
          this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA = this.datePipe.transform(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.cxcimportarndService.insertaencndimpcli(this.cxcimportarndService.encndcli[this.indicador])
        if (data !== null && Object.keys(data).length > 0) {
          for (const iterator of data) {
            this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO = iterator.NUMERO

            for (const item of this.cxcimportarndService.detndcli) {
              if (item.DETNDCLI_FECHA.toString().includes('-')) {
                item.DETNDCLI_FECHA = this.datePipe.transform(item.DETNDCLI_FECHA, 'dd/MM/yyyy')
              }
              item.DETNDCLI_IMPORTE = Number(item.DETNDCLI_IMPORTE);
            }
            let filtroreg = this.cxcimportarndService.detndcli.filter(x => x.DETNDCLI_LINEA === 0)

            const areglodet = filtroreg.map(({ DETNDCLI_LINEA, DETNDCLI_FECHA,
              CLI_CODIGO, VEN_CODIGO, DETNDCLI_TIPODOC, DETNDCLI_CONCEPTO, DETNDCLI_IMPORTE, CON_CODIGO
            }) => ({
              p_ENCNDCLI_NUMERO: iterator.NUMERO,
              p_COM_CODIGO: '01',
              p_DETNDCLI_LINEA: DETNDCLI_LINEA,
              p_DETNDCLI_FECHA: DETNDCLI_FECHA,
              p_CLI_CODIGO: CLI_CODIGO,
              p_VEN_CODIGO: VEN_CODIGO,
              p_DETNDCLI_TIPODOC: DETNDCLI_TIPODOC,
              p_DETNDCLI_CONCEPTO: DETNDCLI_CONCEPTO,
              p_DETNDCLI_IMPORTE: DETNDCLI_IMPORTE,
              p_CON_CODIGO: CON_CODIGO

            }))
            await this.auditoriagral.registrarAuditoria('CXC_ENCNDCLI',
              iterator.NUMERO + '/Concepto:' + this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_CONCEPTO, 'I',
              '', '01', '', '', '', '').toPromise();
              if (areglodet.length>0) {
                await this.cxcimportarndService.insertarregistrodet(areglodet)
              }
            this.messageService.add({
              key: 'cxcimpnd',
              severity: 'success',
              summary: 'Información',
              detail: 'Éxito al guardar '
            });
            this.botonNuevo = false;
            this.botonGuardar = true;
            this.botonBorrar = false;
            this.botonRegresar = true;
            this.botonPrimero = true;
            this.botonAnterior = true;
            this.botonSiguiente = true;
            this.botonUltimo = true;
            await this.encontrarregistro(iterator.NUMERO)
          }
        }
      } else {
        if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA.toString().includes('-')) {
          this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA = this.datePipe.transform(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.cxcimportarndService.actualizaencndimpcli(this.cxcimportarndService.encndcli[this.indicador])
        if (data !== null && Object.keys(data).length > 0) {
          for (const iterator of data) {
            this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO = iterator.NUMERO

            for (const item of this.cxcimportarndService.detndcli) {
              if (item.DETNDCLI_FECHA.toString().includes('-')) {
                item.DETNDCLI_FECHA = this.datePipe.transform(item.DETNDCLI_FECHA, 'dd/MM/yyyy')
              }
              item.DETNDCLI_IMPORTE = Number(item.DETNDCLI_IMPORTE);
            }
            let filtroreg = this.cxcimportarndService.detndcli.filter(x => x.DETNDCLI_LINEA === 0)

            const areglodet = filtroreg.map(({ DETNDCLI_LINEA, DETNDCLI_FECHA,
              CLI_CODIGO, VEN_CODIGO, DETNDCLI_TIPODOC, DETNDCLI_CONCEPTO, DETNDCLI_IMPORTE, CON_CODIGO
            }) => ({
              p_ENCNDCLI_NUMERO: iterator.NUMERO,
              p_COM_CODIGO: '01',
              p_DETNDCLI_LINEA: DETNDCLI_LINEA,
              p_DETNDCLI_FECHA: DETNDCLI_FECHA,
              p_CLI_CODIGO: CLI_CODIGO,
              p_VEN_CODIGO: VEN_CODIGO,
              p_DETNDCLI_TIPODOC: DETNDCLI_TIPODOC,
              p_DETNDCLI_CONCEPTO: DETNDCLI_CONCEPTO,
              p_DETNDCLI_IMPORTE: DETNDCLI_IMPORTE,
              p_CON_CODIGO: CON_CODIGO

            }))
            await this.auditoriagral.registrarAuditoria('CXC_ENCNDCLI',
              iterator.NUMERO + '/Concepto:' + this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_CONCEPTO, 'A',
              '', '01', '', '', '', '').toPromise();
            if (areglodet.length>0) {
              await this.cxcimportarndService.insertarregistrodet(areglodet)
            }
            
            this.messageService.add({
              key: 'cxcimpnd',
              severity: 'success',
              summary: 'Información',
              detail: 'Éxito al guardar '
            });
            this.botonNuevo = false;
            this.botonGuardar = true;
            this.botonBorrar = false;
            this.botonRegresar = true;
            this.botonPrimero = true;
            this.botonAnterior = true;
            this.botonSiguiente = true;
            this.botonUltimo = true;
            await this.encontrarregistro(iterator.NUMERO)
          }
        }
       
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar'
      });
      this.spin = false
      console.log(error)
    }
  }
  cancelar() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.spin = false;
    let numero = isNullOrUndefined(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO) ? '' : this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO
    this.cxcimportarndService.encndcli[this.indicador] = {};
    this.cxcimportarndService.detndcli = [];
    this.detndcliSelected = {}
    this.lblestado = ''
    if (numero === '' || isNullOrUndefined(numero)) {

      document.getElementById('contorno').style.pointerEvents = 'none';
    } else {
      this.encontrarregistro(numero)
    }
  }
  async encontrarregistro(numero) {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.cxcimportarndService.encndcli[this.indicador] = {};
    this.cxcimportarndService.detndcli = [];
    this.detndcliSelected = {}
    this.lblestado = ''
    try {
      this.spin = true;

      const data = await this.cxcimportarndService.getencndimpcli(numero)

      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          iterator.ENCNDCLI_FECHA = new Date(iterator.ENCNDCLI_FECHA)
          this.cxcimportarndService.encndcli[this.indicador] = iterator
          if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_ESTADO === '0') {
            this.lblestado = 'PENDIENTE'
            document.getElementById('contorno').style.pointerEvents = 'all';
          } else if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_ESTADO === '1') {
            this.lblestado = 'PROCESADO'
            document.getElementById('contorno').style.pointerEvents = 'none';
          }
          const data2 = await this.cxcimportarndService.getdetndimpcli(numero)
          if (data2 !== null && Object.keys(data2).length > 0) {
            let numero = 1;
            for (const item of data2) {
              if (item.DETNDCLI_FECHA.toString().includes('-')) {
                item.DETNDCLI_FECHA = this.datePipe.transform(item.DETNDCLI_FECHA, 'dd/MM/yyyy')
              }
              item.DETNDCLI_IMPORTE = this.utilitariosService.formatear(item.DETNDCLI_IMPORTE, 2)
              item.DETNDCLI_NUMERO = numero;
              numero++
            }
            this.cxcimportarndService.detndcli = data2;
          }
          this.spin = false;
        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información'
      });
      this.spin = false;
      console.log(error)
    }
  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    //this.lblbannombre = ''
    this.cxcimportarndService.encndcli[this.indicador] = {
      ENCNDCLI_NUMERO: '',
      COM_CODIGO: '01',
      ENCNDCLI_FECHA: new Date(),
      ENCNDCLI_CONCEPTO: '',
      ENCNDCLI_ESTADO: '0'
    }
    this.lblestado = 'PENDIENTE'
    this.cxcimportarndService.detndcli = [];
    this.detndcliSelected = {}
    document.getElementById('contorno').style.pointerEvents = 'all';
    setTimeout(() => {
      document.getElementById('ENCNDCLI_CONCEPTO').focus();
    }, 100);

  }
  seleccionItem(params) {
    if (params === 'subirxls') {
      if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_ESTADO === '1') {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'El documento ya ha sido procesado, por lo tanto no puede cargar más información '
        });
        this.spin = false
        return;
      }
      if (isNullOrUndefined(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO)) {
        return;
      }
      this.inputfile.nativeElement.click();
      return;
    }
    if (params === 'eliminar') {
      if (this.detndcliSelected.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(this.detndcliSelected.TRNCOBRO_NRODOC) === false) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Información',
          detail: 'No puede eliminar un registro que ya tiene una nota de débito'
        });
        return;
      }
      this.confirmeliminaregistro()
      return
    }
    if (params.object !== undefined) {
      this.detndcliSelected = params.object;
    }
  }
  confirmeliminaregistro() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'cxcimpndconfirm',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let cod = this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO
          if (isNullOrUndefined(cod) || cod === '') {
            this.cxcimportarndService.detndcli = this.cxcimportarndService.detndcli.filter((val, j) => j !==
              this.cxcimportarndService.detndcli.indexOf(this.detndcliSelected));

            this.aggrid.refreshaggrid(this.cxcimportarndService.detndcli, this.defaultCxcdetndcli.objeto);
          } else {
            await this.cxcimportarndService.eliminadetregistro(this.detndcliSelected);

            await this.auditoriagral.registrarAuditoria('CXC_DETNDCLI',
              this.detndcliSelected.ENCNDCLI_NUMERO + '/Cliente:' + this.detndcliSelected.CLI_CODIGO
              + '/Importe:' + this.detndcliSelected.DETNDCLI_IMPORTE, 'E',
              '', '01', '', '', '', '').toPromise();

            this.cxcimportarndService.detndcli = this.cxcimportarndService.detndcli.filter((val, j) => j !==
              this.cxcimportarndService.detndcli.indexOf(this.detndcliSelected));

            this.aggrid.refreshaggrid(this.cxcimportarndService.detndcli, this.defaultCxcdetndcli.objeto);
          }

        } catch (error) {
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un erro durante la eliminación ' + error.error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async onBasicUpload(ev) {
    let validacionVacio = true;
    console.log(ev[0]);
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

      jsonData = workBook.SheetNames.reduce((initial, name) => {
        console.log(workBook.Sheets[name]);
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        return initial;
      }, {});
      console.log(jsonData.Hoja1);

      for (let data of jsonData.Hoja1) {

        delete data.__EMPTY;
        for (let key in data) { // se revisa los campos del json generado del excel,
          // si uno de esos campos no existe o está vacío no se activará el boton de guardar
          if (data[key] === '') {
            validacionVacio = false;
          }

        }
      }
      this.datosJson = jsonData.Hoja1;
      console.log(this.datosJson)
      this.inputfile.nativeElement.value = ''

      await this.validaexcell();

    }
    reader.readAsBinaryString(file);
  }
  async validaexcell() {
    try {
      this.spin = true;
      let linea = 0
      if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO === ''
        || isNullOrUndefined(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO)) {
        this.cxcimportarndService.detndcli = []
      }
      
      const fechanull = Array.from(new Set(this.datosJson.map(item =>
        item.FECHA).filter(x => x === null || String(x).trim() === '')))

      const fechaPosiciones = new Map<string, number[]>();

      this.datosJson.forEach((item, index) => {
        const fecha = item.FECHA
        if (fecha !== null && fecha && String(fecha).trim() !== '') {
          const key = String(fecha).trim();
          if (!fechaPosiciones.has(key)) {
            fechaPosiciones.set(key, [])
          }
          fechaPosiciones.get(key)!.push(index + 2)
        }
      });
      const codclinull = Array.from(new Set(this.datosJson.map(item =>
        item.CODIGO_CLIENTE).filter(x => x === null || String(x).trim() === '')));

      const importenull = Array.from(new Set(this.datosJson.map(item =>
        item.IMPORTE).filter(x => x === null || String(x).trim() === '')));

      const codvennull = Array.from(new Set(this.datosJson.map(item =>
        item.VENDEDOR).filter(x => x === null || String(x).trim() === '')));

      const cntvariosnull = Array.from(new Set(this.datosJson.map(item =>
        item.CNTA_VARIOS).filter(x => x === null || String(x).trim() === '')));

      const cntavariosmayor = Array.from(new Set(this.datosJson.map(item =>
        item.CNTA_VARIOS).filter(x => x.substr(-1, 1) === '.')));

      if (fechanull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya fecha está vacía'
        });
        this.spin = false
        return;
      }
      if (codclinull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya código del cliente está vacío'
        });
        this.spin = false
        return;
      }
      if (importenull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo importe está vacío'
        });
        this.spin = false
        return;
      }
      if (codvennull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo codigo del vendedor está vacío'
        });
        this.spin = false
        return;
      }
      if (cntvariosnull.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya cuenta de varios está vacía'
        });
        this.spin = false
        return;
      }
      if (cntavariosmayor.length > 0) {
        this.messageService.add({
          key: 'cxcimpnd',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen cuentas de mayor en el campo CNTA_VARIOS'
        });
        this.spin = false
        return;
      }

      for (const [fecha, posiciones] of Array.from(fechaPosiciones.entries())) {
        const esValida = await this.esfechaValida(fecha, posiciones[0])
        if (esValida === false) {
          this.spin = false
          return;
        }
      }
      const registros = this.datosJson.map(({ FECHA, TIPO_DOCUMENTO, CONCEPTO, IMPORTE
        , ...resto }) => resto);

      await this.cxcimportarndService.insertartmpdepcli(registros);
      const data = await this.cxcimportarndService.getclivalidacion();
      const data1 = await this.cxcimportarndService.getvenvalidacion();
      const data2 = await this.cxcimportarndService.getconvalidacion();
      const data3 = await this.cxcimportarndService.getconbanvalidacion();

      if (data !== null && data !== undefined) {
        if (data.length > 0) {
          const cadena = data.map(item => String(item.CLI_CODIGO)).join(',')
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes códigos, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      if (data1 !== null && data1 !== undefined) {
        if (data1.length > 0) {
          const cadena = data1.map(item => String(item.VEN_CODIGO)).join(',')
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes vendedores, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      if (data2 !== null && Object.keys(data2).length > 0) {
        if (data2.length > 0) {
          const cadena = data2.map(item => String(item.CON_CODIGO)).join(',')
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar las siguientes cuentas contables del campo CNTA_VARIOS, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      if (data3 !== null && Object.keys(data3).length > 0) {
        if (data3.length > 0) {
          const cadena = data3.map(item => String(item.CON_CODIGO)).join(',')
          this.messageService.add({
            key: 'cxcimpnd',
            severity: 'error',
            summary: 'Error',
            detail: 'Las siguientes cuentas contables del campo CNTA_VARIOS, están registradas en el maestro de bancos, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }

      for (const [fecha, posiciones] of Array.from(fechaPosiciones.entries())) {
        const esValida = await this.esfechaValida(fecha, posiciones[0])
        if (esValida === false) {
          this.spin = false
          return;
        }
      }
      
      for (const item of this.datosJson) {
        if (item.FECHA.toString().includes('-')) {
          item.FECHA = this.datePipe.transform(item.FECHA, 'dd/MM/yyyy')
        }
        const impnd: Cxcdetndcli = {
          ENCNDCLI_NUMERO: isNullOrUndefined(this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO) ? '' : this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_NUMERO,
          COM_CODIGO: '01',
          DETNDCLI_LINEA: 0,
          DETNDCLI_FECHA: item.FECHA,
          CLI_CODIGO: this.convertirTexto(item.CODIGO_CLIENTE, 20),
          VEN_CODIGO: this.convertirTexto(item.VENDEDOR, 4),
          DETNDCLI_TIPODOC: this.convertirTexto(item.TIPO_DOCUMENTO, 48),
          DETNDCLI_CONCEPTO: this.convertirTexto(item.CONCEPTO, 98),
          DETNDCLI_IMPORTE: this.utilitariosService.formatear(item.IMPORTE, 2),
          CON_CODIGO: this.convertirTexto(item.CNTA_VARIOS, 35),
          TRNCOBRO_NRODOC: '',
          DETNDCLI_NUMERO: this.cxcimportarndService.detndcli.length+1
        };
        linea++
        this.cxcimportarndService.detndcli.push(impnd)
      }
      this.aggrid.refreshaggrid(this.cxcimportarndService.detndcli, this.defaultCxcdetndcli.objeto)
    } catch (error) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al cargar los datos, por favor revise el formato de la plantilla y vuelva a cargar: ' + error.error
      });
      console.log(error)
      this.spin = false;
    }


  }
  convertirTexto(valor, numcar) {
    if (valor === null || valor === undefined) {
      return '';
    }
    return String(valor).trim().substring(0, numcar);
  }
  async esfechaValida(fecha, posicion) {
    //console.log(typeof fecha)
    if (typeof fecha !== 'string') {
      return false
    }
    fecha = fecha.trim();
    if (fecha === '') {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha en la posición ' + posicion + ', está vacía'
      });
      //console.log('porque entra al vacío')
      return false
    }
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/
    const match = fecha.match(regex);

    if (!match) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha ' + fecha + ' en la posición ' + posicion + ' no está en el formato correcto dd/MM/yyyy'
      });
      //console.log('porque entra al match')
      return false
    }
    const dia = parseInt(match[1], 10)
    const mes = parseInt(match[2], 10)
    const anio = parseInt(match[3], 10)

    const date = new Date(anio, mes - 1, dia)

    const fechaCorrecta = date.getFullYear() === anio &&
      (date.getMonth() + 1) === mes &&
      date.getDate() === dia;
    if (await this.utilitariosService.verificarPeriodoContable(dia, mes - 1, anio) === false) {
      //console.log('porque entra')
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha ' + fecha + ' en la posición ' + posicion + ' No está dentro del periodo contable '
      })
      return false
    }
    if (fechaCorrecta === false) {
      this.messageService.add({
        key: 'cxcimpnd',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha ' + fecha + ' en la posición ' + posicion + ' No es correcta, por favor revisar que exista '
      })
      return false
    }
    return true
  }
  cambio(params) {
    if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_ESTADO === '0') {
      this.botonNuevo = true;
      this.botonGuardar = false;
      this.botonBorrar = true;
      this.botonRegresar = false;
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
    }

  }
  setFocus(evento) {

  }
  botonesmodificar() {
    if (this.cxcimportarndService.encndcli[this.indicador].ENCNDCLI_ESTADO === '0') {
      this.botonNuevo = true;
      this.botonGuardar = false;
      this.botonBorrar = true;
      this.botonRegresar = false;
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
    }
  }
  changeTabs() {

  }
  manejarSeleccion(opcion) {

    if (this.opcion === 'BUSCARREG') {
      this.encontrarregistro(opcion.ENCNDCLI_NUMERO)
    }
    this.displayDialogBusquedaFast = false
  }
  cerrarReportes() {
    this.displayDialogReportes = false;
  }
}
